export default "__VITE_ASSET__BP$RP869__"